import { scenariosEnabled } from '../constants/scenarios-environment'

// Single place that knows where the access token lives. "Remember me" puts it
// in localStorage, otherwise sessionStorage; reads check localStorage first.
// Session-domain keys (grilaId, tagFilters, solving_time*) are deliberately
// NOT handled here — they belong to the flows that own them.

const TOKEN_KEY = 'token'
export const SCENARIO_TOKEN_KEY = 'scenario-token'

const getScenarioToken = () =>
  scenariosEnabled() ? sessionStorage.getItem(SCENARIO_TOKEN_KEY) : null

export const getStoredToken = () => {
  const scenarioToken = getScenarioToken()
  if (scenarioToken !== null) return scenarioToken || null
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY)
}

export const storeToken = (token: string, rememberMe?: boolean) => {
  if (getScenarioToken() !== null) {
    sessionStorage.setItem(SCENARIO_TOKEN_KEY, token)
    return
  }
  if (rememberMe) {
    localStorage.setItem(TOKEN_KEY, token)
    sessionStorage.removeItem(TOKEN_KEY)
  } else {
    sessionStorage.setItem(TOKEN_KEY, token)
    localStorage.removeItem(TOKEN_KEY)
  }
}

export const clearToken = () => {
  if (getScenarioToken() !== null) {
    // Keep the tab isolated after logout or a 401, rather than falling back to
    // a different account remembered by another tab.
    sessionStorage.setItem(SCENARIO_TOKEN_KEY, '')
    return
  }
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(TOKEN_KEY)
}
